import { Box, Button } from '@material-ui/core';
import { User } from 'core/types';
import { MultiAssignee } from 'pages/lead/components/MultiAssignee';
import { MultiStatusUpdate } from 'pages/lead/components/MultiStatusUpdate';
import { MultiAutomatedEmailEnabled } from 'pages/lead/components/MultiAutomatedEmail';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Admin } from 'store/admin/types';
import { MultiGatherOffers } from 'pages/lead/components/MultiGatherOffers';

interface ToolbarProps {
  onOpenFollowUpModal: () => void;
  onOpenRejectModal: () => void;
  onOpenSendEmailModal: () => void;
  applicationIds?: string[];
  companyIds?: string[];
  isAdmin: boolean;
  admins: Admin[];
  users: User[];
}

const CustomToolbarSelect: FC<ToolbarProps> = ({
  onOpenFollowUpModal,
  onOpenRejectModal,
  onOpenSendEmailModal,
  applicationIds,
  isAdmin,
  admins,
  users,
  companyIds,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box style={{ overflowX: 'auto', width: '90%' }}>
        <Button
          style={{ marginRight: 10, whiteSpace: 'nowrap' }}
          onClick={onOpenFollowUpModal}
          color="primary"
          variant="contained"
        >
          {t('pages.lead.admin.actions.followUp')}
        </Button>
        <Button
          onClick={onOpenRejectModal}
          color="primary"
          variant="contained"
          style={{ marginRight: 10, whiteSpace: 'nowrap' }}
        >
          {t('pages.lead.admin.actions.reject')}
        </Button>

        <Button
          onClick={onOpenSendEmailModal}
          color="primary"
          variant="contained"
          style={{ marginRight: 10, whiteSpace: 'nowrap' }}
        >
          Send Email
        </Button>

        <MultiAssignee isAdmin={isAdmin} admins={admins} users={users} applicationIds={applicationIds || []} />
        <MultiStatusUpdate applicationIds={applicationIds || []} />
        <MultiAutomatedEmailEnabled applicationIds={applicationIds || []} />
        <MultiGatherOffers companyIds={companyIds || []} />
      </Box>

      {/* 
      high value lead -> slack alert

        <Button onClick={onOpenRejectModal} color="primary" variant="contained">
          Send to lenders
        </Button> 
        <Button onClick={onOpenRejectModal} color="primary" variant="contained">
          Assignee to Lender
        </Button> 
        
      Filter max TradingTime

      Notifications get an alert in your Slack (Slack Webhooks) */}
    </>
  );
};

export default CustomToolbarSelect;
